import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
export function PilatesStickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const fn = () => setVisible(window.scrollY > 650);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);
  return <AnimatePresence data-id="element-330" data-mp="3ugc0pslqa6a9">{visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-padel-muted bg-padel-dark/95 p-3 backdrop-blur" data-id="element-331" data-mp="3fp33axbl3gmk"></motion.div>}</AnimatePresence>;
}